module.exports = __webpack_public_path__ + "img/88.82a9d677.png";